import axios from '../library/axiosConfig';
export  default {
  getCurrentCityByIP () {
    return axios.post('/wapHome/getCurrentCityByIP', {}, {baseURL: axios.defaults.baseMgzfURL})
  }
}



// WEBPACK FOOTER //
// ./src/api/mgzf.js